
import { Vue, Component } from 'vue-property-decorator';
import MultipleInput from '@/features/common/components/MultipleInput.vue';

@Component({
  components: {
    MultipleInput,
  },
})
export default class AboutMe extends Vue {
  private industryItems: Array<string> = [
    'Consumer retail',
    'Energy',
    'Health',
    'Media',
    'Sports',
    'Technology',
    'Transportation',
  ]

  private teamSizeItems: Array<string> = [
    '0-10',
    '10-25',
    '50-100',
    '100+',
  ]

  private websites: Array<string> = [];

  private website = '';

  private websiteRegexp = /(https?:\/\/)?(www\.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)|(https?:\/\/)?(www\.)?(?!ww)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/;

  private websiteRules = [
    (v: string): string | boolean => !!v
      || !!this.websites.length
      || this.$t('labels.required') as string,
    (v: string): string | boolean => !!v
      || !!this.websiteRegexp.test(this.website)
      || this.$t('labels.invalidWebsite') as string,
  ];

  get isCommerce(): boolean {
    return this.$store.state.registration.isCommerce;
  }

  private addWebsite(): void {
    this.websites.push(this.website);
    this.website = '';
  }

  private deleteWebsite(idx: number): void {
    this.websites.splice(idx, 1);
  }

  private submit(): void {
    this.$emit('next');
  }
}
